import { comparisonRows } from "@/mocks/comics";

export default function Comparison() {
  return (
    <section id="compare" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-xs font-bold text-primary-700 md:text-sm">
            版本对比
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">免费版和付费版到底差在哪</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            一张表看懂两版差异，帮助你根据自己的阅读习惯，选对最适合的版本。
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-2xl border border-background-200 bg-background-50 md:mt-12">
          <div className="grid grid-cols-3 bg-primary-500 text-center text-background-50">
            <div className="px-2 py-4 text-left text-xs font-bold md:px-6 md:text-sm">功能项</div>
            <div className="px-2 py-4 text-xs font-bold md:px-6 md:text-sm">
              免费版 <span className="ml-1 hidden font-medium text-primary-100 md:inline">(零门槛)</span>
            </div>
            <div className="px-2 py-4 text-xs font-bold md:px-6 md:text-sm">
              付费版 <span className="ml-1 hidden font-medium text-primary-100 md:inline">(会员)</span>
            </div>
          </div>

          {comparisonRows.map((row, index) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 text-center text-sm ${
                index % 2 === 0 ? "bg-background-50" : "bg-secondary-50"
              }`}
            >
              <div className="px-2 py-4 text-left font-medium text-foreground-800 md:px-6">
                {row.feature}
              </div>
              <div className="flex items-center justify-center gap-1.5 px-2 py-4 text-foreground-700 md:px-6">
                <i className="ri-checkbox-circle-line text-accent-600"></i>
                <span className="whitespace-nowrap">{row.free}</span>
              </div>
              <div className="flex items-center justify-center gap-1.5 px-2 py-4 font-medium text-primary-700 md:px-6">
                <i className="ri-vip-crown-2-line text-primary-500"></i>
                <span className="whitespace-nowrap">{row.paid}</span>
              </div>
            </div>
          ))}
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-foreground-600 md:text-sm">
          想先体验再说？完全没问题。免费版已经能满足绝大多数阅读需求，
          升级付费版纯粹是为了更快的更新和更舒适的体验，全凭你的需要选择。
        </p>
      </div>
    </section>
  );
}